module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11469/img/callout-wave.svg"